
export const sStoargeKey = 'spaceDiceLabelRange';

export interface LabelRange {
    min: number;
    max: number;
}

export const useLabelRange = () => {
    const oInitValue:LabelRange = {
        min: 2500,
        max: 7499, // 最新指示： spacedice 默认区间由2500 - 7500 调整成 2500 - 7499 于 2025.04.08 10:17:32 星期二 
    };
    const labelRange = ref(oInitValue);
    onMounted(() => {
        const sData = localStorage.getItem(sStoargeKey) || '{}';
        const oData = JSON.parse(sData);
        if (oData.min >= 0 && oData.max >= 0) {
            labelRange.value = oData;
        }
    });
    return labelRange;
};


const max = 9999; // 最大值
const minGap = 500; // out 模式两端“最小”间距，不能再小了
// ----- ↓ 最大间距设定（两端不能大于此值）--------------------------------
const maxScopeIn = max - minGap;  // in 模式
const maxScopeOut = max - 1; // out 模式

export const spaceDiceConfig = {
    min: 0,
    max,
    fastTime: 250,
    notFastTime: 500,
    // ↓ 以下是 Merlin 后期新增项
    minGap,
    maxScopeIn,
    maxScopeOut,
};


// 左侧向左 | 左侧向右 | 右侧向左 | 右侧向右
export type MoveType = '' | 'll' | 'lr' | 'rl' | 'rr';

export const fnEditor = (
    sMoveType: MoveType,
    inMode: boolean,
    newVal: LabelRange,
)=>{
    if (sMoveType == 'll'){
        const theMost = newVal.max - (inMode ? maxScopeIn : maxScopeOut); 
        return theMost;
        // if (newVal.min < theMost) { return {min: theMost}; }
    }else if (sMoveType == 'lr'){
        const theMost = newVal.max - (inMode ? 0 : minGap);
        return theMost;
        // if (newVal.min > theMost) { return {min: theMost}; }
    }else if (sMoveType == 'rl'){
        const theMost = newVal.min + (inMode ? 0 : minGap);
        return theMost;
        // if (newVal.max < theMost) { return {max: theMost}; }
    }else if (sMoveType == 'rr'){
        const theMost = newVal.min + (inMode ? maxScopeIn : maxScopeOut);
        return theMost;
        // if (newVal.max > theMost) { return {max: theMost}; }
    }
}

